import { createSlice } from '@reduxjs/toolkit';

export const metricSlice = createSlice({
  name: 'metrics',
  initialState: {
    data: {},
  },
  reducers: {
    setMetricsData: (state, action) => {
      state.data = action.payload;
    },
  },
});

export const { setMetricsData } = metricSlice.actions;

export default metricSlice.reducer;
